import React, { useState } from 'react';
import '../App.css';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import { BACKEND_URL } from '../utils/config';

const { REACT_APP_BACKEND_URL, NODE_ENV } = process.env;

if (!REACT_APP_BACKEND_URL && NODE_ENV === 'production') {
    throw new Error('REACT_APP_BACKEND_URL must be set in production.');
}

function Career() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        position: '',
        city: '',
        phone: '',
        email: '',
        resume: null,
        accessToVehicle: '',
        availability: {
            morning: false,
            afternoon: false,
            evening: false,
            weekdays: false,
            weekends: false,
        },
        howHeard: '',
        additionalInformation: '',
    });

    const [status, setStatus] = useState({
        loading: false,
        error: null,
        success: null,
    });

    const handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;

        if (name === 'resume') {
            const file = files[0];
            if (file && file.type !== 'application/pdf') {
                setStatus(prevStatus => ({
                    ...prevStatus,
                    error: 'Only PDF files are accepted for the resume.',
                    success: null,
                }));
                e.target.value = ''; // Clear the file input
                setFormData(prevFormData => ({
                    ...prevFormData,
                    resume: null,
                }));
                return;
            }
            setStatus(prevStatus => ({
                ...prevStatus,
                error: null,
            })); // Clear error if a valid file is selected
            setFormData(prevFormData => ({
                ...prevFormData,
                resume: file,
            }));
        } else if (type === 'checkbox' && name === 'availability') {
            setFormData(prevState => ({
                ...prevState,
                availability: {
                    ...prevState.availability,
                    [value]: checked
                }
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, error: null, success: null });

        const payload = new FormData();
        payload.append('firstName', formData.firstName);
        payload.append('lastName', formData.lastName);
        payload.append('position', formData.position);
        payload.append('city', formData.city);
        payload.append('phone', formData.phone);
        payload.append('email', formData.email);
        payload.append('resume', formData.resume);
        payload.append('accessToVehicle', formData.accessToVehicle);
        payload.append('availability', JSON.stringify(formData.availability));
        payload.append('howHeard', formData.howHeard);
        payload.append('additionalInformation', formData.additionalInformation);

        try {
            const response = await fetch(`${BACKEND_URL}/others/apply`, {
                method: 'POST',
                body: payload,
            });

            if (!response.ok) {
                let message = `Failed to submit application. (${response.status} ${response.statusText})`;
                try {
                    const errData = await response.json();
                    if (errData && typeof errData.message === 'string' && errData.message.trim() !== '') {
                        message = errData.message;
                    }
                } catch (parseError) {
                    // Ignore JSON parsing errors and fall back to the default message.
                }
                throw new Error(message);
            }

            let successMessage = 'Application submitted successfully!';
            try {
                const result = await response.json();
                if (result && typeof result.message === 'string' && result.message.trim() !== '') {
                    successMessage = result.message;
                }
            } catch (parseError) {
                // Ignore JSON parsing errors and use the default success message.
            }

            setStatus({ loading: false, error: null, success: successMessage });
            // Reset form
            setFormData({
                firstName: '',
                lastName: '',
                position: '',
                city: '',
                phone: '',
                email: '',
                resume: null,
                accessToVehicle: '',
                availability: {
                    morning: false,
                    afternoon: false,
                    evening: false,
                    weekdays: false,
                    weekends: false,
                },
                howHeard: '',
                additionalInformation: '',
            });
            e.target.reset();
        } catch (error) {
            setStatus({ loading: false, error: error.message, success: null });
        };
    }

  return (
    <div className='App'>
        <TopBar />
        <div style={{
        padding: '40px 20px',
        maxWidth: '1200px',
        margin: '0 auto',
        marginTop: '10vh'
        }}>
        <h1 className="hero-title">Join Our Team</h1>

        <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            marginBottom: '30px'
        }}>
            <h2 style={{ marginBottom: '20px' }}>Current Opportunities</h2>
            <p style={{ marginBottom: '20px' }}>
            At Connection Health Care, we're always looking for passionate individuals who share our commitment
            to providing exceptional care for seniors. Join our team of dedicated professionals and make a
            real difference in people's lives.
            </p>

            <div style={{ marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '15px' }}>Open Positions:</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ 
                marginBottom: '20px',
                padding: '20px',
                border: '1px solid #eee',
                borderRadius: '5px'
                }}>
                <h4 style={{ marginBottom: '10px' }}>Personal Support Worker (PSW)</h4>
                <p style={{ marginBottom: '10px' }}>Full-time & Part-time positions available</p>
                
                <div style={{ marginTop: '15px' }}>
                  <h5 style={{ marginBottom: '10px', fontWeight: 'bold' }}>Job Description:</h5>
                  
                  <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>Job Summary</h6>
                  <p style={{ marginBottom: '15px', lineHeight: '1.5' }}>
                    We are seeking compassionate and dedicated Healthcare Personnel/Personal Support Workers (PSW) to provide essential support to individuals in various care settings, including assisted living facilities, nursing homes, and home care environments. The ideal candidate will play a vital role in enhancing the quality of life for seniors and individuals with disabilities by delivering personalized care and assistance tailored to their unique needs.
                  </p>

                  <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>Responsibilities</h6>
                  <div style={{ marginBottom: '15px', lineHeight: '1.4', textAlign: 'left' }}>
                    <p style={{ margin: '5px 0' }}>Assist clients with daily living activities such as bathing, dressing, grooming, and meal preparation.</p>
                    <p style={{ margin: '5px 0' }}>Administer medications as prescribed and monitor clients for any side effects or changes in condition.</p>
                    <p style={{ margin: '5px 0' }}>Provide companionship and emotional support to enhance the well-being of clients.</p>
                    <p style={{ margin: '5px 0' }}>Maintain a clean and safe environment for clients by performing light housekeeping duties.</p>
                    <p style={{ margin: '5px 0' }}>Support individuals with disabilities in their daily routines and activities.</p>
                    <p style={{ margin: '5px 0' }}>Assist with mobility and transfers, ensuring safety at all times.</p>
                    <p style={{ margin: '5px 0' }}>Document care provided and report any changes in client health or behavior to the supervising nurse or healthcare professional.</p>
                    <p style={{ margin: '5px 0' }}>Engage clients in meaningful activities that promote cognitive function, especially for those with dementia care needs.</p>
                  </div>

                  <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>Skills</h6>
                  <div style={{ marginBottom: '15px', lineHeight: '1.4', textAlign: 'left' }}>
                    <p style={{ margin: '5px 0' }}>Proven experience in caregiving within assisted living, nursing home, or home care settings is highly desirable.</p>
                    <p style={{ margin: '5px 0' }}>Knowledge of medication administration protocols and best practices.</p>
                    <p style={{ margin: '5px 0' }}>Strong organizational skills with the ability to maintain a clean environment while managing multiple tasks effectively.</p>
                    <p style={{ margin: '5px 0' }}>Compassionate approach towards senior care and individuals with disabilities.</p>
                    <p style={{ margin: '5px 0' }}>Excellent communication skills to interact effectively with clients, families, and healthcare team members.</p>
                    <p style={{ margin: '5px 0' }}>Ability to demonstrate patience, empathy, and understanding when working with clients suffering from dementia or other cognitive impairments.</p>
                    <p style={{ margin: '5px 0' }}>Flexibility to adapt to changing client needs and schedules while providing consistent support.</p>
                  </div>
                </div>
                <div style={{ marginTop: '15px' }}>
                  <p style={{ marginBottom: '10px', fontStyle: 'italic' }}>
                    Join our team of dedicated professionals committed to making a difference in the lives of those we serve!
                  </p>

                  <p style={{ marginBottom: '5px' }}><strong>Job Types:</strong> Full-time, Part-time</p>
                  <p style={{ marginBottom: '5px' }}><strong>Language:</strong> English (preferred)</p>
                  <p><strong>Work Location:</strong> In person</p>
                </div>
                </li>

                {/* <li style={{ 
                marginBottom: '20px',
                padding: '20px',
                border: '1px solid #eee',
                borderRadius: '5px'
                }}>
                <h4 style={{ marginBottom: '10px' }}>Registered Nurse (RN)</h4>
                <p style={{ marginBottom: '10px' }}>Full-time positions available</p>
                <p style={{ textAlign: 'center', marginBottom: '10px' }}>Requirements:</p>
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                    <p style={{ margin: '5px 0' }}>Current RN license with CNO</p>
                    <p style={{ margin: '5px 0' }}>Minimum 2 years of nursing experience</p>
                    <p style={{ margin: '5px 0' }}>Experience in geriatric care preferred</p>
                    <p style={{ margin: '5px 0' }}>Strong clinical assessment skills</p>
                    <p style={{ margin: '5px 0' }}>Excellence in team collaboration</p>
                </div>
                </li> */}
            </ul>
            </div>

            <div style={{
            background: '#f9f9f9',
            padding: '30px',
            borderRadius: '5px',
            marginBottom: '30px'
            }}>
            <h3 style={{ marginBottom: '20px' }}>Apply Now</h3>
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '8px' }}>First Name *</label>
                    <input 
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                    />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: '8px' }}>Last Name *</label>
                    <input 
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                    />
                </div>
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>Designation/Position Applying For *</label>
                <select 
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                >
                    <option value="">Select a position</option>
                    <option value="PSW">Personal Support Worker (PSW)</option>
                    <option value="RN">Registered Nurse (RN)</option>
                </select>
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>City of Residence *</label>
                <input 
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                    />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '8px' }}>Phone Number *</label>
                    <input 
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                    />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: '8px' }}>Email *</label>
                    <input 
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}
                    />
                </div>
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>Access to Vehicle *</label>
                <select 
                    name="accessToVehicle"
                    value={formData.accessToVehicle}
                    onChange={handleChange}
                    required
                    style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                    }}
                >
                    <option value="">Select an option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                </select>
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>Availability *</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" name="availability" value="morning" checked={formData.availability.morning} onChange={handleChange} /> Morning
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" name="availability" value="afternoon" checked={formData.availability.afternoon} onChange={handleChange} /> Afternoon
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" name="availability" value="evening" checked={formData.availability.evening} onChange={handleChange} /> Evening
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" name="availability" value="weekdays" checked={formData.availability.weekdays} onChange={handleChange} /> Weekdays
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" name="availability" value="weekends" checked={formData.availability.weekends} onChange={handleChange} /> Weekends
                    </label>
                </div>
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>How did you hear about us? *</label>
                <select 
                    name="howHeard"
                    value={formData.howHeard}
                    onChange={handleChange}
                    required
                    style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                    }}
                >
                    <option value="">Select an option</option>
                    <option value="website">Company Website</option>
                    <option value="jobBoard">Job Board</option>
                    <option value="socialMedia">Social Media</option>
                    <option value="referral">Employee Referral</option>
                    <option value="other">Other</option>
                </select>
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>Resume/CV *</label>
                <input 
                    type="file"
                    name="resume"
                    accept=".pdf"
                    onChange={handleChange}
                    required
                    style={{
                        width: '100%',
                        padding: '8px'
                    }}
                />
                </div>

                <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>Additional Information (Optional)</label>
                <textarea 
                    name="additionalInformation"
                    value={formData.additionalInformation}
                    onChange={handleChange}
                    rows="5"
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ddd',
                        minHeight: '100px'
                    }}
                />
                </div>

                <button 
                type="submit"
                disabled={status.loading}
                style={{
                    padding: '12px 20px',
                    background: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    opacity: status.loading ? 0.6 : 1,
                }}
                >
                {status.loading ? 'Submitting...' : 'Submit Application'}
                </button>

                {status.error && <p style={{ color: 'red' }}>{status.error}</p>}
                {status.success && <p style={{ color: 'green' }}>{status.success}</p>}
            </form>
            </div>
        </div>
        <Footer />
    </div>
    </div>
    );
}

export default Career;
